import React from 'react';
import './mobileSwipeModal.scss';
import ClearIcon from '@mui/icons-material/Clear';
import { MobileContainer } from '../../responsiveTools/ResponsiveContainers';

export const MobileSwipeModal = ({
    open,
    onClose,
    children,
    title
}) => {

    const handleClose = () => {
        const element = document.getElementById('mobile-modal');
        if (element) {
            element.style.animation = 'slide-down-modal 0.2s';
            setTimeout(() => {
                onClose();
            }, 100);
        }
    }

    return (
        <>
            {open ?
                <MobileContainer>
                    <div className='mobile-swipe-modal-background'>
                        <div id='mobile-modal' className={`mobile-modal-content`}>
                            <div className='mobile-filters-row'>
                                {title &&
                                    <span className='mobile-filters-title'>{title}</span>
                                }
                                {onClose &&
                                    <ClearIcon onClick={handleClose} className='close-icon' />
                                }
                            </div>
                            <div>
                                {children}
                            </div>
                        </div>
                    </div>
                </MobileContainer>
                : null}
        </>
    )
}